// QRTemplateGrid.jsx
import React from 'react';
import styled from '@emotion/styled';

const TemplateGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0.75rem;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

const TemplateCard = styled.button`
  background: ${({ active }) =>
    active ? 'rgba(124, 58, 237, 0.25)' : 'rgba(255, 255, 255, 0.05)'};
  border: 1px solid
    ${({ active }) =>
      active ? 'rgba(124, 58, 237, 0.4)' : 'rgba(255, 255, 255, 0.1)'};
  border-radius: 12px;
  padding: 0.875rem;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  color: ${({ active }) => (active ? '#ffffff' : 'rgba(255, 255, 255, 0.8)')};
  min-height: 80px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;

  &:hover {
    background: ${({ active }) =>
      active ? 'rgba(124, 58, 237, 0.3)' : 'rgba(124, 58, 237, 0.15)'};
    border-color: rgba(124, 58, 237, 0.3);
    color: #ffffff;
    transform: translateY(-1px);
  }

  &:active {
    transform: scale(0.98);
  }
`;

const TemplatePreview = styled.div`
  width: 32px;
  height: 32px;
  background: ${({ background }) => background};
  border-radius: 6px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  position: relative;
  overflow: hidden;
  flex-shrink: 0;

  /* Add some visual patterns for different templates */
  ${({ templateId }) => {
    switch (templateId) {
      case 'dots':
        return `
          &::after {
            content: '';
            position: absolute;
            inset: 6px;
            background-image: radial-gradient(circle, rgba(255,255,255,0.4) 1.5px, transparent 1.5px);
            background-size: 6px 6px;
          }
        `;
      case 'rounded':
        return `border-radius: 8px;`;
      case 'gradient':
        return `background: linear-gradient(45deg, #7c3aed, #ec4899) !important;`;
      default:
        return '';
    }
  }}
`;

const TemplateName = styled.div`
  font-size: 0.75rem;
  font-weight: 600;
  line-height: 1.2;
`;

const QRTemplateGrid = ({ selectedTemplate, onTemplateSelect }) => {
  const templates = [
    {
      id: 'basic',
      name: 'Basic',
      preview: '#000000',
    },
    {
      id: 'rounded',
      name: 'Rounded',
      preview: '#2563eb',
    },
    {
      id: 'dots',
      name: 'Dots',
      preview: '#059669',
    },
    {
      id: 'modern',
      name: 'Modern',
      preview: '#dc2626',
    },
  ];

  return (
    <TemplateGrid>
      {templates.map((template) => (
        <TemplateCard
          key={template.id}
          active={selectedTemplate === template.id}
          onClick={() => onTemplateSelect(template.id)}
        >
          <TemplatePreview
            background={template.preview}
            templateId={template.id}
          />
          <TemplateName>{template.name}</TemplateName>
        </TemplateCard>
      ))}
    </TemplateGrid>
  );
};

export default QRTemplateGrid;
